import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  chooseImportSession,
  fetchMigrationImportStatus,
} from '~/store/actions/migration'
import {
  getCurrentSessionId,
  getProgressEntities,
} from '~/store/reducers/migration'

import CoreMigrationProgressComponent from './CoreMigrationProgressComponent'

const StepImportDone = () => {
  const dispatch = useDispatch()
  const sessionId = useSelector(getCurrentSessionId)
  const entities = useSelector(getProgressEntities) || []

  useEffect(() => {
    if (sessionId) {
      dispatch(fetchMigrationImportStatus(sessionId))
    }
  }, [sessionId])

  return (
    <CoreMigrationProgressComponent
      finished
      entities={entities}
      onOk={() => dispatch(chooseImportSession(null))}
    />
  )
}

export default StepImportDone
